import { useState, useEffect, Fragment } from "react";
import VoiceCallRTC from "./VoiceCallRTC";
import { IoMdCall } from "react-icons/io";
import ringtone from "../../../sounds/ringtone.wav";

export default function VoiceCall({
  infrastructure,
  voiceCallState,
  isMobile,
}) {
  const [localStream, setLocalStream] = useState(null);

  const { send } = infrastructure;

  const grey = "#DBDEE3";
  const red = "#DC3545";
  const green = "#50AF82";

  useEffect(() => {
    if (isMobile) return;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        setLocalStream(stream);
      })
      .catch((err) => {
        console.log("error while getting user media:", err);
      });
  }, [isMobile]);

  function handleClickAnswer(vuiId) {
    send("infrastructure", "answerCall", vuiId);
  }

  function handleClickEndCall(vuiId) {
    send("infrastructure", "endCall", vuiId);
  }

  function iconButton(IconType, onClick, color) {
    return (
      <div
        style={{
          width: 50,
          height: 50,
          margin: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: color,
          borderRadius: "50%",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <IconType size="30px" color="white" />
      </div>
    );
  }

  function voiceCallLine(text, buttonElt, reverse, key, className) {
    const textElt = (
      <div
        style={{
          flexGrow: 1,
          textAlign: reverse ? "right" : "left",
        }}
      >
        {text}
      </div>
    );
    return (
      <div
        style={{
          height: 60,
          backgroundColor: grey,
          borderRadius: 30,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingLeft: reverse ? 0 : 30,
          paddingRight: reverse ? 30 : 0,
          fontSize: "20px",
		      boxShadow: "0 0 .3em rgba(0, 0, 0, .4)",
        }}
        className={className}
        key={key}
      >
        {reverse ? buttonElt : textElt}
        <div style={{ width: 10 }}></div>
        {reverse ? textElt : buttonElt}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        right: 10,
        gap: 10,
      }}
      className="scrollfixed"
    >
      {!isMobile && !localStream
        ? voiceCallLine(
            <span style={{ color: red, paddingRight: 20 }}>
              microphone disabled
            </span>,
            null,
            false,
            undefined,
            "fadeInSlow"
          )
        : null}
      {voiceCallState?.callCandidates?.map((candidate) => {
        return voiceCallLine(
          <>
            <span style={{ fontWeight: "bold" }}>{candidate}</span>
            <span> is calling</span>
          </>,
          iconButton(IoMdCall, () => handleClickAnswer(candidate), green),
          true,
          candidate
        );
      })}
      {voiceCallState?.callCandidates?.length > 0 ? (
        <audio
          loop={true}
          src={ringtone}
          autoPlay={true}
        ></audio>
      ) : null}
      {voiceCallState?.inCallWithOperator
        ?.filter(
          (candidate) =>
            !voiceCallState?.inCallWithPeer
              ?.map((peer) => peer.vuiId)
              .includes(candidate)
        )
        .map((candidate) => {
          return voiceCallLine(
            <>
              <span>Speaking with</span>
              <span style={{ fontWeight: "bold" }}> {candidate}</span>
              <span> on your other device</span>
            </>,
            iconButton(IoMdCall, () => handleClickEndCall(candidate), red),
            false,
            candidate
          );
        })}
      {localStream
        ? voiceCallState?.inCallWithPeer?.map((candidate) => {
            return (
              <Fragment key={candidate.vuiId}>
                {voiceCallLine(
                  <>
                    <span>Speaking with</span>
                    <span style={{ fontWeight: "bold" }}>
                      {" "}
                      {candidate.vuiId}
                    </span>
                  </>,
                  iconButton(
                    IoMdCall,
                    () => handleClickEndCall(candidate.vuiId),
                    red
                  ),
                  false,
                  undefined
                )}
                <VoiceCallRTC
                  serverState={candidate}
                  infrastructureSend={send}
                  localStream={localStream}
                  key={candidate.vuiId}
                />
              </Fragment>
            );
          })
        : null}
    </div>
  );
}
